/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileHeaderBreadcrumbs_tradeFirm = {
    readonly name: string | null;
    readonly " $refType": "ProfileHeaderBreadcrumbs_tradeFirm";
};
export type ProfileHeaderBreadcrumbs_tradeFirm$data = ProfileHeaderBreadcrumbs_tradeFirm;
export type ProfileHeaderBreadcrumbs_tradeFirm$key = {
    readonly " $data"?: ProfileHeaderBreadcrumbs_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileHeaderBreadcrumbs_tradeFirm">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ProfileHeaderBreadcrumbs_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '748bb967227fc1a338ffaace8c071d34';
export default node;
